import { useDispatch, useSelector } from "react-redux";

// Actions
import { setSort } from "redux/game/slice";

// Components
import GameSortDesktop from "components/organisms/GameSortDesktop";

// Selectors
import * as gamesSelector from "redux/game/selectors";

const GameSortDesktopContainer = () => {
  const dispatch = useDispatch();
  const { sort } = useSelector(gamesSelector.filter);
  const setMethod = (option: string) => {
    dispatch(setSort(option));
  };
  // eslint-disable-next-line react/jsx-handler-names
  return <GameSortDesktop selected={sort} onSelect={setMethod} />;
};

export default GameSortDesktopContainer;
